var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"division"}},[_c('div',{staticClass:"cent"},[_c('soso',{on:{"addinfo":_vm.addinfo2}})],1),_c('iteminfo',{attrs:{"tableData":_vm.allinfo},on:{"dele":_vm.dele}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }